// Shared
import { AssetType, values } from '@oddr/user-schemas';

export const MediaTypeFilter = {
  ...AssetType,
  All: '',
} as const;

export type MediaTypeFilter = values<typeof MediaTypeFilter>;
